import { Unit, UnitsTime, UnitTime } from 'fabscale-app/models/enums/units';

export default function unitIsDurationHelper(unit: Unit) {
  return UnitsTime.includes(unit as UnitTime);
}
